export const SUPPORT_EMAIL = 'plumeria-support@microsoft.com';

const DEFAULT_ACCESS_REQUEST_SUBJECT = 'Plumeria Access Request';

/**
 * Builds an Outlook Web compose deep link rather than a `mailto:` URL. `mailto:`
 * depends on the OS having a mail handler registered for the protocol; when it
 * points at a browser with no handler the click silently opens a blank tab.
 */
export const buildAccessRequestUrl = (subject: string = DEFAULT_ACCESS_REQUEST_SUBJECT): string =>
  'https://outlook.office.com/mail/deeplink/compose' +
  `?to=${encodeURIComponent(SUPPORT_EMAIL)}` +
  `&subject=${encodeURIComponent(subject)}`;

/** Names the blocked area in the subject so support knows what was requested. */
export const buildPageAccessRequestSubject = (area?: string): string =>
  area ? `${DEFAULT_ACCESS_REQUEST_SUBJECT}: ${area}` : DEFAULT_ACCESS_REQUEST_SUBJECT;

export const ACCESS_REQUEST_URL = buildAccessRequestUrl();
